export default "__VITE_ASSET__Cu44Fvzb__"